import { useNavigate } from 'react-router-dom';
import type { Group } from '../../types/admin';

interface GroupTableProps {
  groups: Group[];
}

export default function GroupTable({ groups }: GroupTableProps) {
  const navigate = useNavigate();

  const handleRowClick = (locationId: number) => {
    navigate(`/admin/groups/${locationId}/edit`);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Name</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Location</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Latitude</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Longitude</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Devices</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Users</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-600 uppercase">Description</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {groups.map((group) => (
            <tr
              key={group.locationId}
              onClick={() => handleRowClick(group.locationId)}
              className="hover:bg-blue-50 cursor-pointer transition-colors duration-150"
            >
              <td className="px-4 py-2 whitespace-nowrap font-medium">{group.locationName}</td>
              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-600">
                {group.locationCode || '-'}
              </td>
              <td className="px-4 py-2 whitespace-nowrap">{group.latitude?.toFixed(6) ?? '-'}</td>
              <td className="px-4 py-2 whitespace-nowrap">{group.longitude?.toFixed(6) ?? '-'}</td>
              <td className="px-4 py-2 whitespace-nowrap text-center">{group.deviceCount ?? 0}</td>
              <td className="px-4 py-2 whitespace-nowrap text-center">{group.userCount ?? 0}</td>
              <td className="px-4 py-2 max-w-xs truncate">{group.description || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {groups.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No groups found. Create your first group to get started.
        </div>
      )}
    </div>
  );
}
